import { render, staticRenderFns } from "./PemberitahuanDetail.vue?vue&type=template&id=4522c9cb"
import script from "./PemberitahuanDetail.vue?vue&type=script&lang=js"
export * from "./PemberitahuanDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports